export default __webpack_public_path__ + "static/media/profile-active.52b47176.svg";